// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.up-success {
	padding: 1.25rem;
	background: #f0fdf4;
	border: 1px solid #bbf7d0;
	border-radius: 0.375rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/update-password/update-password.component.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,yBAAyB;CACzB,uBAAuB;AACxB","sourcesContent":[".up-success {\n\tpadding: 1.25rem;\n\tbackground: #f0fdf4;\n\tborder: 1px solid #bbf7d0;\n\tborder-radius: 0.375rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
